<template>
    <div>


        <div class="xinz" v-if="$store.getters.ismobilePhone == false">
            <div class="right">
                <el-button type="warning" @click="customerAdd" v-if="canAdd"><i class="fa fa-plus"/> 新增</el-button>
            </div>
        </div>
        <div v-if="!$store.getters.ismobilePhone">
            <el-form :inline="true" class="demo-form-inline" size="small" @submit.native.prevent
                     @keyup.native.enter="getCustomerList">
                <el-form-item label="搜索條件：">
					
                    <el-input placeholder="客戶編號/姓名/電話" clearable v-model="searchName">
                    </el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-select v-model="searchSalesId" filterable clearable placeholder="銷售員">
                        <el-option
                                v-for="item in salesList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            <span style="float: left">{{ item.name }}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px;text-align: left;margin-left:10px;">{{ item.loginName
                                }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getCustomerList"><i class="fa fa-search"/>查詢</el-button>
                </el-form-item>
            </el-form>
        </div>
        <!--手机端搜索-->
        <div v-if="$store.getters.ismobilePhone" style="width: 110%;">
            <div @click="homeClick" class="banckFont">客戶列表</div>
            <el-form style="margin:12px 0 12px 0;" :inline="true" class="demo-form-inline" size="small"
                     @submit.native.prevent @keyup.native.enter="getCustomerList">

                <el-input style="width: 110px;" placeholder="編號/姓名/電話" v-model="searchName">
                </el-input>


                <el-select style="width: 90px;" v-model="searchSalesId" filterable clearable placeholder="銷售員">
                    <el-option
                            v-for="item in salesList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        <span style="float: left">{{ item.name }}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px;text-align: left;margin-left:10px;">{{ item.loginName
                            }}</span>
                    </el-option>
                </el-select>


              <el-button type="primary" @click="getCustomerList"><i class="fa fa-search"/>查詢</el-button>

            </el-form>

        </div>

        <div id="app">
            <!-- 手机  -->

            <el-table :header-cell-style="{background:'rgba(39,116,244,0.1)',color:'#333333'}" border
                      style="width: 100%;" v-loading="customerTableloading" :data="customerList"
                      v-if="$store.getters.ismobilePhone" @row-click="selDetails">
                <el-table-column prop="code" label="客戶編號" width="110%"></el-table-column>
                <el-table-column prop="name" label="姓名"></el-table-column>
                <el-table-column prop="id" label="操作" width="100%" align="center">
                    <span @click="selDetails(scope.row)" style="color: #4B78FF;">查看</span>
                    <!-- <el-button  @click.native="selDetails(scope.row)" type="primary" size="medium">查看</el-button> -->
                </el-table-column>
                <!--<template slot-scope="scope">-->
                <!--<el-button  @click.native="selDetails(scope.row)" type="primary" size="medium">详情</el-button>-->

                <!--&lt;!&ndash;<el-dropdown >&ndash;&gt;-->
                <!--&lt;!&ndash;<el-button size="small" type="primary" >&ndash;&gt;-->
                <!--&lt;!&ndash;<i  class="fa fa-mouse-pointer"/> 操作&ndash;&gt;-->
                <!--&lt;!&ndash;</el-button>&ndash;&gt;-->
                <!--&lt;!&ndash;<el-dropdown-menu slot="dropdown">&ndash;&gt;-->
                <!--&lt;!&ndash;<el-dropdown-item  @click.native="selDetails(scope.row)"  ><i class="fa fa-search-plus"/> 詳情</el-dropdown-item>&ndash;&gt;-->
                <!--&lt;!&ndash;</el-dropdown-menu>&ndash;&gt;-->
                <!--&lt;!&ndash;</el-dropdown>&ndash;&gt;-->
                <!--</template>-->
                <!--</el-table-column>-->
            </el-table>

            <!-- 电脑  -->
            <el-table :header-cell-style="{background:'#4B78FF',color:'#FFFFFF'}" border style="width: 100%;"
                      v-loading="customerTableloading" :data="customerList" v-else>
                <el-table-column prop="code" label="客戶編號" width="200"></el-table-column>
                <el-table-column prop="name" label="姓名"></el-table-column>
                <el-table-column prop="phone" label="電話" width="200"></el-table-column>
                <el-table-column prop="sales" label="銷售員" width="200"></el-table-column>
                <!--<el-table-column prop="address" label="地址"></el-table-column>-->
                <!--<el-table-column prop="createDate" label="創建時間"></el-table-column>-->
                <el-table-column prop="id" label="操作" width="100%" align="center">
                    <template slot-scope="scope">
                        <el-dropdown>
                            <el-button size="small" type="primary">
                                <i class="fa fa-mouse-pointer"/> 操作
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item @click.native="customerEdit(scope.row)" v-if="canEdit">
                                    <i class="fa fa-edit"/> 編輯
                                </el-dropdown-item>
                                <el-dropdown-item @click.native="selDetails(scope.row)" v-if="canDetail"><i
                                        class="fa fa-search-plus"/> 詳情
                                </el-dropdown-item>
                                <el-dropdown-item @click.native="handleDelete(scope.row)" v-if="canDel"><i
                                        class="fa fa-trash"/> 刪除
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!--分頁 -->
        <div class="pagination" >
			
            <el-pagination v-if="!$store.getters.ismobilePhone"
			
                    layout="total, prev, pager, next"

                    @current-change="handleCurrentChange"
                    :current-page.sync="pager.page"
                    :page-size="pager.size"
                    :total="pager.total">
            </el-pagination>
			<el-pagination v-if="$store.getters.ismobilePhone"
			  small
			layout="total, prev, pager, next"
			
			@current-change="handleCurrentChange"
			:current-page.sync="pager.page"
			:page-size="pager.size"
			:total="pager.total">
			</el-pagination>
			
			<!-- <el-pagination v-if="$store.getters.ismobilePhone"
			
			        layout="total, prev, pager, next"
			
			        @current-change="handleCurrentChange"
			        :current-page.sync="pager.page"
			        :page-size="pager.size"
			        :total="pager.total">
			</el-pagination> -->
        </div>

        <!--&lt;!&ndash;編輯頁面&ndash;&gt;-->
        <el-dialog :title="dialogName" :visible.sync="dialogDiscEditVisible" width="400px">
            <el-form :model="customerForm" ref="customerForm" label-width="130px" size="small">
                <el-row :gutter="0">
                    <el-col :span="24">
                        <el-form-item label="客戶編號:" prop="code">
                            <el-input v-model="customerForm.code" @change="itemChange(customerForm.code)" type="text"
                                      style="width:200px" placeholder="請輸入客戶編號"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="姓名:" prop="name">
                            <el-input v-model="customerForm.name" auto-complete="off" style="width:200px"
                                      placeholder="請輸入姓名"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="電話:" prop="phone">
                            <el-input v-model="customerForm.phone" auto-complete="off" style="width:200px"
                                      placeholder="請輸入電話"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="地址:" prop="address">
                            <!--<el-input v-model="customerForm.address"   auto-complete="off" style="width:200px" placeholder="請輸入地址"></el-input>-->
                            <el-input
                                    type="textarea"
                                    :autosize="{ minRows: 4, maxRows:18}"
                                    style="width:200px"
                                    placeholder="請輸入地址"
                                    v-model="customerForm.address">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="銷售員：" prop="salesId">
                            <el-select v-model="customerForm.salesId" filterable placeholder="" style="width:200px;">
                                <el-option
                                        v-for="item in salesList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                    <span style="float: left">{{ item.name }}</span>
                                    <span style="float: right; color: #8492a6; font-size: 13px">{{ item.loginName
                                        }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <!-- <el-form-item style="width:437px"  label="銷售員:" prop="sales">
                             <el-select  v-model="customerForm.sales" clearable filterable reserve-keyword remote @focus="clickLoad()" style="width: 65%" size="medium"
                                         placeholder="請輸入銷售員"  :remote-method="remoteMethodSales" :loading="tableloading" >
                                 <el-option
                                         v-for="item in saList"
                                         :key="item.value"
                                         :label="item.label"
                                         :value="item.value">
                                 </el-option>
                             </el-select>
                         </el-form-item>-->
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-check" @click="customerSave">確 定</el-button>
                            <el-button @click="dialogDiscEditVisible = false" icon="el-icon-delete">取 消</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import {
        getCustomerList,
        insertCustomer,
        getValidateCustomerCode,
        getSalesList,
        getCustomerById,
        updateCustomer,
        getStaffAllList,
        validateCustomerById,
        deleteCustomerById
    } from '../api/api'

    export default {
        methods: {
            remoteMethodSales(query) {/*選擇銷售員*/
                if (query !== '') {
                    this.loading = true;
                    setTimeout(() => {
                        this.loading = false;
                        this.salesList = this.saList.filter(item => {
                            return item.label.toLowerCase()
                                    .indexOf(query.toLowerCase()) > -1;
                        });
                    }, 200);
                } else {
                    this.salesList = [];
                }
            },
            homeClick()
            {
                // console.log("etetert");
                this.$router.push({
                    name: '倉庫一覽'
                })
            },
            clickLoad(){/*點擊銷售員框時載入*/
                //this.saList =[];
                this.salesList = this.saList;
            },
            getCustomerList(){
                this.customerTableloading = true;
                var params = {
                    page: this.pager.page,
                    size: this.pager.size,
                    name: this.searchName.trim(),
                    salesId: this.searchSalesId
                };
                return getCustomerList(params).then(data => {
                    let {data: res = {}} = data;
                    if (res.errcode == 200) {
                        let {size, page, total, data: items = []} = res.data;
                        this.customerList = items;
                        this.isDate();
                        this.pager.total = total;
                        this.pager.page = page;
                        this.pager.size = size;
                        this.customerTableloading = false;

                    } else {
                        this.$message.error(res.errmsg);
                    }
                });
            },
            isDate(){/*處理日期*/
                this.customerList.forEach((a, i) => {
                    a.createDate = new Date(a.createDate * 1000).Format("yyyy-MM-dd hh:mm:ss")//new Date(a.createDate*1000).Format("yyyy-MM-dd hh:mm")
                })
            },
            querySearch(queryString, cb) {/*載入數據*/
                var restaurants = this.customerCode;
                var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
                // 調用 callback 返回建議清單的資料
                cb(results);
            },
            createFilter(queryString) {
                return (restaurant) => {
                    return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            itemChange(value){
                this.customerForm.code = value.toUpperCase();
                if (this.customerForm.id == "") {
                    var params = {code: this.customerForm.code};
                    return getValidateCustomerCode(params).then(data => {
                        let item = data.data.data;
                        if (item) {
                            this.$alert("客戶編號重複！", '提示', {
                                confirmButtonText: '確定',
                                callback: action => {
                                    this.customerForm.code = "";
                                }
                            });
                        }
                    });
                } else if (this.customerForm.id != "") {
                    if (this.isCFcode != this.customerForm.code) {
                        var params = {code: this.customerForm.code};
                        return getValidateCustomerCode(params).then(data => {
                            let item = data.data.data;
                            if (item) {
                                this.$alert("客戶編號重複！", '提示', {
                                    confirmButtonText: '確定',
                                    callback: action => {
                                        this.customerForm.code = "";
                                    }
                                });
                            }
                        });
                    }
                }
            },
            letSalesList(){/*查詢銷售員LIST*/
                return getSalesList().then(data => {
                    let {data: res = {}} = data;
                    //console.log(res)
                    if (res.errcode === 200) {
                        let salesOnMap = new Map();
                        res.data.forEach((item, i) => {
                            salesOnMap.set(i, {id: item.id, value: item.name});
                        });
                        let list = [... salesOnMap.values()];
                        this.saList = list.map(item => {
                            return {value: item.value, label: item.value};
                        });
                    }
                });
            },
            handleCurrentChange(val){
                this.getCustomerList();
            },
            handleSelectionChange(val){
                this.selectionItems = val;
            },
            customerAdd(index, row){
                this.dialogName = "新增客戶資訊",
                this.customerForm.id = "";
                this.resetForm("customerForm");

                this.dialogDiscEditVisible = true;
            },
            customerEdit(row) {
                this.dialogName = "編輯客戶資訊",
                    this.dialogDiscEditVisible = true;
                this.resetForm("customerForm");
                this.customerById(row.id);
            },
            handleDelete(row) {
                this.$confirm('妳確定要刪除客戶：' + row.code + "嗎?", this.$t('m.m_info'), {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: this.$t('m.t_confirm'),
                    cancelButtonText: this.$t('m.t_cancel'),
                    type: 'warning'
                }).then(() => {
                    return validateCustomerById(row.id).then(data => {
                        let item = data.data;
                        if (item.errcode == 200) {
                            if (item.data > 0) {
                                this.$message.warning("客戶有倉存信息，不能刪除！");
                            } else {
                                deleteCustomerById(row.id).then(data => {
                                    let {data: res = {}} = data;
                                    if (res.errcode == 200) {
                                        this.$message.success('刪除成功');
                                        this.getCustomerList();
                                    } else {
                                        this.$message.error(res.errmsg);
                                    }
                                });
                            }
                        } else {
                            this.$message.error(item.errmsg);
                        }
                    });
                });
            },
            getSalseVal(val){
                let obj = this.salesList.find(v => v.id == val);
                if (obj == undefined) {
                    return "";
                } else {
                    return obj.name;
                }
            },
            customerById(id){
                return getCustomerById(id).then(data => {
                    let item = data.data;
                    if (item.errcode == 200) {
                        this.isCFcode = item.data[0].code;
                        Object.assign(this.customerForm, item.data[0]);
                    } else {
                        this.$message.error(item.errmsg);
                    }
                });
            },
            selDetails(row){   //查看客戶詳情資訊
                this.$store.commit("setSearchSte", false);
                this.$router.push({
                    name: '客戶詳情',
                    params: {
                        id: row.id
                    }
                })
            },
            customerSave(){
                /*this.$refs.customerForm.validate((valid) => {*/
                let str = this.isNull();
                if (str !== "") {
                    this.dialogVisible = true;
                    this.$alert(str, '提示', {
                        confirmButtonText: '確定',
                        type: 'error'
                    });
                } else {
                        if (this.customerForm.id == "") {       //新增
                            this.addEidtloading = true;
                            //var  params=Object.assign({},this.customerForm);
                            var params = {
                                code: this.customerForm.code,
                                name: this.customerForm.name,
                                phone: this.customerForm.phone,
                                address: this.customerForm.address,
                                sales: this.customerForm.sales,
                                salesId: this.customerForm.salesId
                            };
                            insertCustomer(params).then(data => {
                                this.addEidtloading = false;
                                let {data: res = {}} = data;
                                if (res.errcode == 200) {
                                    this.$message.success("新增成功！！");
                                    this.getCustomerList();
                                    this.resetForm("customerForm");
                                    this.dialogDiscEditVisible = false;
                                } else {
                                    this.$message.error(res.errmsg);
                                }
                            }, err => {
                                this.addEidtloading = false;
                            });
                        } else {                          //編輯
                            var params = {
                                id: this.customerForm.id,
                                code: this.customerForm.code,
                                name: this.customerForm.name,
                                phone: this.customerForm.phone,
                                sales: this.customerForm.sales,
                                address: this.customerForm.address,
                                salesId: this.customerForm.salesId
                            };
                            updateCustomer(params).then(data => {
                                this.addEidtloading = false;
                                let {data: res = {}} = data;
                                if (res.errcode == 200) {
                                    this.$message.success("修改成功");
                                    this.getCustomerList();
                                    this.resetForm("customerForm");
                                    this.dialogDiscEditVisible = false;
                                } else {
                                    this.$message.error(res.errmsg);
                                }
                            }, err => {
                                this.addEidtloading = false;
                            });
                        }
                    }
            },

            //清除表單內容
            resetForm(formName){
                if (this.$refs[formName] !== undefined) {
                    this.$refs[formName].resetFields();
                }
            },
            isNull(){/*是否为空*/
                if (this.customerForm.code === "" || this.customerForm.code === null) {
                    return "客戶編號不能為空"
                } else if (this.customerForm.code.length > 20) {
                    return "客戶編號不能大於20位"
                }
                if (this.customerForm.name === "" || this.customerForm.name === null) {
                    return "姓名不能為空"
                }else if(this.customerForm.name.length > 50){
                    return "姓名不能大於50位"
                }
                if (this.customerForm.phone === "" || this.customerForm.phone === null) {
                    return "電話不能為空"
                }else if(this.customerForm.phone.length > 30){
                    return "電話不能大於30位"
                }
                if (this.customerForm.address === "" || this.customerForm.address === null) {
                    return "地址不能為空"
                } else if (this.customerForm.address.length > 255) {
                    return "地址長度不能大於255位"
                }
                if (this.customerForm.salesId === "" || this.customerForm.salesId === null) {
                    return "銷售員不能為空"
                }
                return "";
            },
        },
        data() {
            var validateNumber = (rule, value, callback) => {
                var reg = /^[1-15]\d*$/;
                if (value != "" && value != null) {
                    if (!reg.test(value)) {
                        callback(new Error(this.$t('m.canOnlyEnterPositiveNumber')));
                    }
                }
                callback();
            };

            //驗證客戶編號是否重複
//            var validateCustomerCode=(rule, value, callback) => {
//                var params={code:this.customerForm.code};
//                return getValidateCustomerCode(params).then(data=>{
//                    if(this.customerForm.id == '') {
//                        let item = data.data.data;
//                        if (item) {
//                            callback(new Error('客戶編號重複！'));
//                        } else {
//                            callback();
//                        }
//                    }
//                });
//                callback();
//            };
            return {
                //查詢準則
                searchBankName: "",
                customerList: [],
                salesList: [],//銷售員LIST
                saList: [],//銷售員LIST
                selectionItems: [],
                tableloading: false,
                addEidtloading: false,
                dialogDiscEditVisible: false,
                customerTableloading: false,
                isCFcode: "",
                pager: {
                    page: 0,
                    size: 15,
                    total: 0
                },
                dialogName: '',
                searchName: '',
                searchSalesId: '',
                customerForm: {
                    id: "",
                    sales: "",
                    salesId: "",
                    code: "",
                    name: "",
                    phone: "",
                    address: ''
                },
                //新增客戶資訊表單驗證
//                customerRules: {
//                    code: [
//                        {required: true, message: '請輸入客戶編號', trigger: 'blur' },
//                        {max:30,message:"客戶編號最多只能30位元",trigger:'blur'},
//                        { validator: validateCustomerCode,trigger: 'blur' }
//                    ],
//                    name:[
//                        {required: true, message: '請輸入客戶名', trigger: 'blur' },
//                        {max:30,message:"客戶名最多只能20位元",trigger:'change'},
//                    ],
//                    phone:[
//                        {required: true, message: '請輸入手機號', trigger: 'blur' },
//                        {max:16,message:"手機號最多只能16位",trigger:'blur'}
//                    ],
//                    address:[
//                        {required: true, message: '請輸入位址', trigger: 'blur' }
//                    ],
//                    sales:[
//                        {required: true, message: '請選擇銷售員', trigger: 'blur' }
//                    ]
//                }
            }
        },

//        mounted() {
//
//        },
        computed: {
            canAdd(){
                return this.$store.getters.hasPermission("CUST_ADD");
            },
            canEdit(){
                return this.$store.getters.hasPermission("CUST_EDIT");
            },
            canDel(){
                return this.$store.getters.hasPermission("CUST_DEL");
            },
            canDetail(){
                return this.$store.getters.hasPermission("CUST_DETAILS");
            },

        },
        activated(){
            getStaffAllList().then(data => {
                let {data: res = {}} = data;
                this.salesList = res.data;
            });
            Date.prototype.Format = function (fmt) {
                var o = {
                    "M+": this.getMonth() + 1, //月份
                    "d+": this.getDate(), //日
                    "h+": this.getHours(), //小時
                    "m+": this.getMinutes(), //分
                    "s+": this.getSeconds(), //秒
                    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
                    "S": this.getMilliseconds() //毫秒
                };
                if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
                for (var k in o)
                    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
                return fmt;
            };
            this.getCustomerList();
        },

    }

</script>

<style lang="scss" scoped>
    .el-form-item {
        margin-bottom: 5px;
    }

    .menu {
        .right {
            float: right;
        }
    }

    .el-tag + .el-tag {
        margin-left: 5px;
    }

    .xinz button {
        background: #4B78FF;
        border: none;
        margin-bottom: 1rem;
    }

    .xinz button:hover {
        background: #215ec3;
        color: #fff;
    }

    .el-input--medium .el-input__inner {
        border: 1px solid;
    }
</style>




// WEBPACK FOOTER //
// src/views/Customer.vue